import { closeIcon, h } from './utils'

export class Popup {
  readonly elements: {
    readonly root: HTMLDivElement
    readonly body: HTMLDivElement
    readonly container: HTMLDivElement
    readonly close: HTMLButtonElement
  }

  protected timeout?: number

  constructor() {
    const root = h('div', { class: 'vbzc-popup' }) as HTMLDivElement
    const body = h('div', { class: 'vbzc-popup-body' }, { parent: root }) as HTMLDivElement
    const container = h('div', { class: 'vbzc-popup-container' }, { parent: body }) as HTMLDivElement
    const close = h(
      'button',
      { 'class': 'vbzc-popup-close-button vbzc-close-button', 'aria-label': 'Close' },
      { parent: body, children: [closeIcon()] },
    ) as HTMLButtonElement

    this.onEscapeKey = this.onEscapeKey.bind(this)

    root.addEventListener('click', () => this.hide())
    body.addEventListener('click', (event) => event.stopPropagation())
    close.addEventListener('click', () => this.hide())

    this.elements = { root, body, container, close }
  }

  show() {
    document.body.append(this.elements.root)

    clearTimeout(this.timeout)
    setTimeout(() => {
      this.elements.root.classList.add('vbzc-popup-visible')
    })

    window.addEventListener('keydown', this.onEscapeKey)

    return this
  }

  hide() {
    this.elements.root.classList.remove('vbzc-popup-visible')

    clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => {
      this.elements.root.remove()
    }, 150)

    window.removeEventListener('keydown', this.onEscapeKey)

    const queryString = new URLSearchParams(window.location.search)
    if (queryString.has('vacancy')) {
      queryString.delete('vacancy')
      const qs = queryString.toString()
      window.history.pushState({}, '', qs ? `${window.location.pathname}?${qs}` : window.location.pathname)
    }

    return this
  }

  clear() {
    this.elements.container.innerHTML = ''
    return this
  }

  protected onEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.hide()
    }
  }
}
